/* CreativeWall お部屋に飾ったイメージ 2026-10-02
   - 単位はすべて mm。家具と作品を同じ縮尺で描くので、サイズ感がそのまま伝わる
   - サイズの読み取り順：選択中のバリエーション名 → 商品タイプ → 説明文 → 商品名 → タグ
   - 号数しか書かれていない場合は、キャンバスの規格寸法（F・P・M・S）を使う */
(function () {
  'use strict';

  var root = document.querySelector('[data-cw-room]');
  var dataEl = document.querySelector('[data-cw-room-data]');
  if (!root || !dataEl) return;
  var P;
  try { P = JSON.parse(dataEl.textContent); } catch (e) { return; }

  // キャンバスの規格寸法（長辺×短辺）
  var T = {
    F: { 0: [180, 140], SM: [227, 158], 1: [220, 160], 2: [240, 190], 3: [273, 220], 4: [333, 242], 5: [350, 270], 6: [410, 318], 8: [455, 380], 10: [530, 455], 12: [606, 500], 15: [652, 530], 20: [727, 606], 25: [803, 652], 30: [910, 727], 40: [1000, 803], 50: [1167, 910], 60: [1303, 970], 80: [1455, 1120], 100: [1620, 1303] },
    P: { 0: [180, 120], SM: [227, 140], 1: [220, 140], 2: [240, 160], 3: [273, 190], 4: [333, 220], 5: [350, 225], 6: [410, 273], 8: [455, 333], 10: [530, 410], 12: [606, 455], 15: [652, 500], 20: [727, 530], 25: [803, 606], 30: [910, 652], 40: [1000, 727], 50: [1167, 803], 60: [1303, 894], 80: [1455, 970], 100: [1620, 1120] },
    M: { 0: [180, 100], SM: [227, 120], 1: [220, 120], 2: [240, 140], 3: [273, 160], 4: [333, 190], 5: [350, 190], 6: [410, 242], 8: [455, 273], 10: [530, 333], 12: [606, 410], 15: [652, 410], 20: [727, 455], 25: [803, 500], 30: [910, 606], 40: [1000, 606], 50: [1167, 727], 60: [1303, 803], 80: [1455, 894], 100: [1620, 970] },
    S: { 0: [180, 180], SM: [227, 227], 1: [220, 220], 2: [240, 240], 3: [273, 273], 4: [333, 333], 5: [350, 350], 6: [410, 410], 8: [455, 455], 10: [530, 530], 12: [606, 606], 15: [652, 652], 20: [727, 727], 25: [803, 803], 30: [910, 910], 40: [1000, 1000], 50: [1167, 1167], 60: [1303, 1303] }
  };

  function norm(s) {
    return String(s || '')
      .replace(/[０-９]/g, function (c) { return String.fromCharCode(c.charCodeAt(0) - 0xFEE0); })
      .replace(/[Ａ-Ｚａ-ｚ]/g, function (c) { return String.fromCharCode(c.charCodeAt(0) - 0xFEE0); })
      .replace(/㎜/g, 'mm').replace(/㎝/g, 'cm').replace(/[✕☓＊*ｘ]/g, '×');
  }
  function inRange(n) { return n >= 80 && n <= 3000; }

  // 1つの文字列からサイズを読む
  function parse(s) {
    s = norm(s);
    var r = {};
    var m = s.match(/W\s*約?\s*(\d{2,4})\s*(mm)?\s*[×xX]\s*H\s*(\d{2,4})/i);
    if (m && inRange(+m[1]) && inRange(+m[3])) { r.w = +m[1]; r.h = +m[3]; r.explicit = true; }
    if (!r.w) {
      m = s.match(/(\d{2,4}(?:\.\d)?)\s*(mm|cm)?\s*[×xX]\s*(\d{2,4}(?:\.\d)?)\s*(mm|cm)?/);
      if (m) {
        var k = (m[2] === 'cm' || m[4] === 'cm') ? 10 : 1;
        var a = Math.round(+m[1] * k), b = Math.round(+m[3] * k);
        if (inRange(a) && inRange(b)) { r.w = a; r.h = b; }
      }
    }
    var d = s.match(/D\s*約?\s*(\d{1,3})\s*mm/i);
    if (d) r.d = +d[1];
    var c = s.match(/([FPMS])\s*-?\s*(SM|\d{1,3})\s*号/i);
    if (c) {
      var ser = c[1].toUpperCase(), no = c[2].toUpperCase();
      r.code = ser + (no === 'SM' ? '-SM' : no) + '号';
      if (!r.w && T[ser] && T[ser][no]) { r.w = T[ser][no][0]; r.h = T[ser][no][1]; r.std = true; }
    }
    return r.w ? r : (r.code ? r : null);
  }

  function currentVariant() {
    var input = document.querySelector('input[name="variant_id"]:checked, product-info form input[name="id"], form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] select[name="id"]');
    var id = input ? +input.value : P.selected;
    var v = null;
    (P.variants || []).forEach(function (x) { if (x.id === id) v = x; });
    return v || (P.variants || [])[0];
  }

  function getSize(v) {
    var sources = [];
    if (v && v.title && v.title !== 'Default Title') sources.push(v.title);
    sources.push(P.type, P.description, P.title, (P.tags || []).join(' '));
    var code = null;
    for (var i = 0; i < sources.length; i++) {
      var r = parse(sources[i]);
      if (!r) continue;
      if (r.code && !code) code = r.code;
      if (r.w) {
        r.code = r.code || code || tagCode();
        if (r.std) {
          // 号数だけの場合は、同じ号数で寸法が書かれている箇所（商品タイプなど）を優先
          for (var k = i + 1; k < sources.length; k++) {
            var q = parse(sources[k]);
            if (q && q.w && !q.std && q.code === r.code) { q.d = q.d || r.d; r = q; break; }
          }
        }
        if (!r.d) { var dd = parse(P.description); if (dd && dd.d) r.d = dd.d; }
        return r;
      }
    }
    // タグの「S0」「F6」など
    var tags = P.tags || [];
    for (var j = 0; j < tags.length; j++) {
      var t = norm(tags[j]).match(/^([FPMS])(SM|\d{1,3})$/i);
      if (t) { var r2 = parse(t[1] + t[2] + '号'); if (r2 && r2.w) return r2; }
    }
    return null;
  }

  function tagCode() {
    var tags = P.tags || [];
    for (var j = 0; j < tags.length; j++) {
      var t = norm(tags[j]).match(/^([FPMS])(SM|\d{1,3})$/i);
      if (t) return t[1].toUpperCase() + t[2] + '号';
    }
    return null;
  }

  var userImage = null;
  function getImage(v) {
    if (userImage) return userImage;
    if (v && v.image) return v.image;
    return P.image;
  }

  // 向き：説明文に W×H があればそれに従い、なければ画像の縦横に合わせる
  function orient(size, img) {
    var w = size.w, h = size.h;
    if (size.explicit || w === h || !img) return { w: w, h: h };
    var long = Math.max(w, h), short = Math.min(w, h);
    var ratio = img.w / img.h;
    if (ratio < 0.98) return { w: short, h: long };
    return { w: long, h: short };
  }

  function fmt(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }

  // ---------- 部屋の描画 ----------
  function rect(x, y, w, h, fill, rx, extra) {
    return '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" fill="' + fill + '"' + (rx ? ' rx="' + rx + '"' : '') + (extra || '') + '/>';
  }
  function ell(cx, cy, rx, ry, fill, rot) {
    return '<ellipse cx="' + cx + '" cy="' + cy + '" rx="' + rx + '" ry="' + ry + '" fill="' + fill + '"' + (rot ? ' transform="rotate(' + rot + ' ' + cx + ' ' + cy + ')"' : '') + '/>';
  }

  var SCENES = [
    {
      key: 'living', caption: 'リビング｜ソファ幅 約2,000mm',
      W: 3600, bottom: -260, minShow: 420, top: 820, gap: 230,
      wall: ['#f1ede6', '#e6e0d6'], floor: '#cfb28c',
      draw: function () {
        var s = '';
        s += ell(0, 30, 1550, 40, '#e9dfcf');
        // ソファ
        s += rect(-930, -70, 40, 70, '#5e4b39') + rect(890, -70, 40, 70, '#5e4b39');
        s += rect(-1000, -460, 2000, 390, '#7d8a7a', 40);
        s += rect(-940, -820, 1880, 420, '#8f9c8c', 70);
        s += rect(-900, -780, 880, 330, '#9eab9b', 60) + rect(20, -780, 880, 330, '#9eab9b', 60);
        s += rect(-830, -500, 820, 130, '#a7b3a4', 40) + rect(10, -500, 820, 130, '#a7b3a4', 40);
        s += rect(-1000, -640, 190, 580, '#76836f', 80) + rect(810, -640, 190, 580, '#76836f', 80);
        s += '<rect x="-760" y="-700" width="300" height="260" rx="50" fill="#dcc5b0" transform="rotate(-8 -610 -570)"/>';
        // フロアランプ
        s += ell(1450, -12, 170, 24, '#3b3b3b') + rect(1440, -1500, 20, 1490, '#3b3b3b');
        s += '<polygon points="1300,-1500 1600,-1500 1540,-1760 1360,-1760" fill="#efe5d3"/>';
        // 観葉植物
        s += ell(-1450, -820, 70, 300, '#6c8b67', -20) + ell(-1380, -760, 70, 280, '#7f9c78', 25) + ell(-1510, -700, 60, 240, '#5f7d5a', -45) + ell(-1430, -980, 60, 220, '#7f9c78', 5) + ell(-1360, -620, 55, 200, '#6c8b67', 50);
        s += rect(-1570, -430, 240, 430, '#d7cdc0', 30);
        return s;
      }
    },
    {
      key: 'bedroom', caption: '寝室・ダイニング｜チェスト幅 約1,200mm',
      W: 2800, bottom: -200, minShow: 300, top: 765, gap: 260,
      wall: ['#efe8de', '#e4dccf'], floor: '#c4a27a',
      draw: function () {
        var s = '';
        s += rect(-560, -120, 30, 120, '#6e5640') + rect(530, -120, 30, 120, '#6e5640');
        s += rect(-600, -740, 1200, 620, '#b88f66', 10);
        s += rect(-620, -765, 1240, 30, '#9d7651', 6);
        s += '<path d="M0 -740 V -120 M-600 -535 H600 M-600 -330 H600" stroke="#9d7651" stroke-width="8" fill="none"/>';
        [-640, -437, -230].forEach(function (y) { s += '<circle cx="-70" cy="' + y + '" r="14" fill="#7d5d40"/><circle cx="70" cy="' + y + '" r="14" fill="#7d5d40"/>'; });
        // 花瓶
        s += '<path d="M380 -1010 L300 -1350 M380 -1010 L430 -1420 M380 -1010 L480 -1260" stroke="#7a6a55" stroke-width="9" fill="none" stroke-linecap="round"/>';
        s += ell(300, -1350, 40, 22, '#9fb08f', -30) + ell(430, -1420, 40, 22, '#9fb08f', 20) + ell(480, -1260, 40, 22, '#9fb08f', 40);
        s += ell(380, -885, 95, 125, '#ebe5db') + rect(352, -1030, 56, 70, '#ebe5db', 10);
        // 本
        s += rect(-470, -805, 190, 40, '#c9b79c', 4) + rect(-460, -845, 170, 40, '#8e9e8a', 4) + rect(-450, -875, 150, 30, '#d6c6b0', 4);
        return s;
      }
    },
    {
      key: 'desk', caption: 'デスクまわり｜デスク幅 約1,000mm・ノートPC',
      W: 1900, bottom: 260, minShow: 640, top: 750, gap: 300,
      wall: ['#f3f1ed', '#e9e6e0'], floor: '#bfa07c',
      draw: function () {
        var s = '';
        s += rect(-480, -720, 30, 720, '#4a4a4a') + rect(450, -720, 30, 720, '#4a4a4a');
        s += rect(-500, -735, 1000, 30, '#a07a55', 4);
        // ノートPC（13インチ）
        s += rect(-225, -750, 320, 15, '#c9ccd1', 4);
        s += rect(-210, -965, 290, 215, '#2f3237', 8) + rect(-200, -955, 270, 195, '#4f5b68', 4);
        // ライト
        s += ell(330, -742, 70, 12, '#333');
        s += '<path d="M330 -742 L300 -1050 L420 -1150" stroke="#333" stroke-width="14" fill="none" stroke-linejoin="round"/>';
        s += '<polygon points="390,-1190 470,-1120 430,-1080 360,-1150" fill="#333"/>';
        // マグカップ・本
        s += rect(170, -830, 70, 95, '#f2efe9', 8);
        s += rect(-430, -965, 38, 230, '#8e9e8a', 3) + rect(-390, -985, 38, 250, '#c9b79c', 3) + rect(-350, -945, 38, 210, '#b27a62', 3);
        return s;
      }
    }
  ];

  function sceneSVG(sc, art, img, label) {
    var aspect = 0.75;
    var W = Math.max(sc.W, art.w + 700);
    var H = W * aspect;
    var bottom = sc.bottom;
    var artBottom = sc.top + sc.gap;           // 床からの高さ
    var artTop = artBottom + art.h;
    var need = artTop + W * 0.07;               // 作品の上の余白（寸法の文字）
    if (need > bottom + H) {
      bottom = need - H;
      if (bottom > sc.minShow) {                // 家具が見えなくなる場合は引いて（縮小して）全体を写す
        bottom = sc.minShow;
        H = need - bottom; W = H / aspect;
      }
    }
    var vb = [-W / 2, -(bottom + H), W, H].map(function (n) { return Math.round(n); }).join(' ');
    var id = 'cw-' + sc.key;
    var ax = -art.w / 2, ay = -artTop;
    var fs = Math.round(W * 0.028);
    var s = '<svg viewBox="' + vb + '" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="' + sc.caption + 'に ' + label + ' の作品を飾ったイメージ">';
    s += '<defs><linearGradient id="' + id + '-wall" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="' + sc.wall[0] + '"/><stop offset="1" stop-color="' + sc.wall[1] + '"/></linearGradient>';
    s += '<filter id="' + id + '-sh" x="-20%" y="-20%" width="140%" height="150%"><feDropShadow dx="' + Math.round(W * 0.003) + '" dy="' + Math.round(W * 0.005) + '" stdDeviation="' + Math.round(W * 0.004) + '" flood-color="#000" flood-opacity=".28"/></filter></defs>';
    s += rect(-6000, -8000, 12000, 8000, 'url(#' + id + '-wall)');
    s += rect(-6000, 0, 12000, 2000, sc.floor);
    s += '<path d="M-6000 60 H6000 M-6000 150 H6000 M-6000 260 H6000" stroke="rgba(0,0,0,.06)" stroke-width="6"/>';
    s += rect(-6000, -45, 12000, 45, '#f8f6f1');
    s += sc.draw();
    // 作品
    s += '<g filter="url(#' + id + '-sh)">' + rect(ax, ay, art.w, art.h, '#d9d4cc') + '</g>';
    if (img && img.src) {
      s += '<image href="' + img.src + '" x="' + ax + '" y="' + ay + '" width="' + art.w + '" height="' + art.h + '" preserveAspectRatio="xMidYMid slice"/>';
    }
    s += rect(ax, ay, art.w, art.h, 'none', 0, ' stroke="rgba(0,0,0,.14)" stroke-width="' + Math.max(1.5, W * 0.0006) + '"');
    // 寸法
    var ly = ay - fs * 0.9;
    s += '<g fill="none" stroke="#6b6b6b" stroke-width="' + Math.max(2, W * 0.0007) + '"><path d="M' + ax + ' ' + (ly + fs * 0.35) + ' H' + (ax + art.w) + ' M' + ax + ' ' + (ly) + ' V' + (ly + fs * 0.7) + ' M' + (ax + art.w) + ' ' + ly + ' V' + (ly + fs * 0.7) + '"/></g>';
    s += '<text x="0" y="' + (ly - fs * 0.25) + '" text-anchor="middle" font-size="' + fs + '" font-weight="700" fill="#333" font-family="sans-serif">' + label + '</text>';
    s += '</svg>';
    return '<figure class="cw-room__scene" data-scene="' + sc.key + '">' + s + '<figcaption>' + sc.caption + '</figcaption></figure>';
  }

  var grid = root.querySelector('[data-cw-room-grid]');
  var sizeEl = root.querySelector('[data-cw-room-size]');
  var lastKey = '';

  function render() {
    var v = currentVariant();
    var size = getSize(v);
    var spec = document.querySelector('[data-cw-spec]');
    if (!size || !size.w) {
      root.hidden = true;
      if (spec) { var row = spec.querySelector('[data-cw-spec-size]'); if (row) row.hidden = true; }
      return;
    }
    var img = getImage(v);
    var art = orient(size, img);
    var label = 'W' + fmt(art.w) + ' × H' + fmt(art.h) + ' mm';
    var key = label + '|' + (img && img.src);
    if (key === lastKey) return;
    lastKey = key;
    var full = 'W' + fmt(art.w) + ' × H' + fmt(art.h) + (size.d ? ' × D' + size.d : '') + ' mm' + (size.code ? '（' + size.code + '）' : '');
    sizeEl.textContent = full;
    grid.innerHTML = SCENES.map(function (sc) { return sceneSVG(sc, art, img, label); }).join('');
    root.hidden = false;
    if (spec) {
      var sv = spec.querySelector('[data-cw-spec-size-value]');
      if (sv) {
        sv.innerHTML = '<strong>' + 'W' + fmt(art.w) + '×H' + fmt(art.h) + (size.d ? '×D' + size.d : '') + 'mm</strong>' + (size.code ? ' ' + size.code : '') + '<br><small style="color:var(--cw-sub)">' + compare(art) + '</small>';
        spec.querySelector('[data-cw-spec-size]').hidden = false;
      }
      var jump = spec.querySelector('[data-cw-spec-jump]');
      if (jump) jump.hidden = false;
      spec.hidden = false;
    }
  }

  // 身近な物との比較（目安）
  function compare(a) {
    var long = Math.max(a.w, a.h);
    if (long <= 200) return 'ハガキ（148mm）よりひと回り大きい目安';
    if (long <= 300) return 'A4用紙（297mm）くらいの目安';
    if (long <= 430) return 'A3用紙（420mm）くらいの目安';
    if (long <= 620) return 'A2用紙（594mm）くらいの目安';
    if (long <= 850) return 'A1用紙（841mm）くらいの目安';
    return '1mを超える大きなサイズ';
  }

  // 発送の目安（商品の発送欄が空で、説明文に書かれている場合）
  (function shipping() {
    var spec = document.querySelector('[data-cw-spec]');
    if (!spec) return;
    if (spec.querySelector('.cw-spec__row:not([hidden])')) spec.hidden = false;
    var cur = spec.querySelector('[data-cw-spec-ship]');
    if (cur && !cur.hidden) return;
    // ページ内の「発送について」欄
    var heads = document.querySelectorAll('.product__text .product__heading, .cw-pinfo > summary');
    for (var i = 0; i < heads.length; i++) {
      if (/発送/.test(heads[i].textContent)) {
        var body = heads[i].parentElement.querySelector('.product__subheading, .cw-pinfo__body');
        var tx = body ? body.textContent.replace(/\s+/g, ' ').trim() : '';
        if (tx && cur) { tx = tx.split('。')[0] + (tx.indexOf('。') > -1 ? '。' : ''); cur.querySelector('dd').textContent = tx.length > 70 ? tx.slice(0, 70) + '…' : tx; cur.hidden = false; spec.hidden = false; return; }
      }
    }
    var m = norm(P.description).match(/(\d{1,2})\s*日?\s*[～〜~ー-]\s*(\d{1,2})\s*(?:日)?\s*営業日/);
    var row = spec.querySelector('[data-cw-spec-ship]');
    if (m && row) {
      row.querySelector('dd').textContent = '注文確定後 ' + m[1] + '〜' + m[2] + '営業日で発送';
      row.hidden = false;
      spec.hidden = false;
    }
  })();

  // 手元の画像で試す（画面の中だけで使い、送信しない）
  var file = root.querySelector('[data-cw-room-file]');
  if (file) {
    file.addEventListener('change', function () {
      var f = file.files && file.files[0];
      if (!f) return;
      var url = URL.createObjectURL(f);
      var im = new Image();
      im.onload = function () { userImage = { src: url, w: im.naturalWidth, h: im.naturalHeight }; lastKey = ''; render(); };
      im.src = url;
    });
  }

  // クリックで拡大（PC）
  grid.addEventListener('click', function (e) {
    var fig = e.target.closest('.cw-room__scene');
    if (!fig || window.innerWidth < 750) return;
    var on = !fig.classList.contains('is-zoom');
    grid.querySelectorAll('.is-zoom').forEach(function (x) { x.classList.remove('is-zoom'); });
    if (on) fig.classList.add('is-zoom');
  });

  // バリエーション（サイズ）の変更に追従
  document.addEventListener('change', function (e) {
    if (e.target.closest && (e.target.name === 'variant_id' || e.target.closest('form, product-info, variant-selects, [data-product]'))) setTimeout(render, 250);
  });
  document.addEventListener('theme:product-info:loaded', function () { setTimeout(render, 100); });
  window.addEventListener('popstate', function () { setTimeout(render, 250); });

  render();
})();
